module.exports = __webpack_public_path__ + "img/menu-icon.d21fdadf.svg";